import { create, update } from 'lodash';
import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import formAppSportRoomBlackouts from '../formAppSportRoomBlackouts';
import formAppComposeExperienceTagNew from '../formAppComposeExperienceTagNew';
import formAppComposeExperienceTagEdit from '../formAppComposeExperienceTagEdit';

export default {
  attributeName: 'composeExperienceTags',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  canRemoveWhen: [{ field: 'tagType', values: ['person', 'action', 'context', 'environment','actor'] }],
  isMultiSelectable: false,
  newButton: true,
  createURL: 'composeExperience/tagging',
  getURL: 'composeExperience/tagging',
  updateURL: 'composeExperience/tagging',
  removeURL: 'composeExperience/tagging',
  popupContentFormNew: [formAppComposeExperienceTagNew],
  popupContentFormEdit: [formAppComposeExperienceTagEdit],
  sessionParams: [],
  emptyMessage: "No media tags have been added to this media yet.",
  fields: [
    {
      attributeName: 'tagName',
      label: 'Tag Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Name of the tag.',
    },
    {
      attributeName: 'tagType',
      label: 'Tag Type',
      helpText: 'Set the tag type of the media tag.',
      default: '(Empty)',
      type: FormInputTypes.SELECT,
      options: [
        { name: '(No action)', value: '(Empty)' },
        { name: 'Actor', value: 'actor' },
        { name: 'Context', value: 'context' },
      ],
      className: 'd-inline-block col-sm-4',
    },
    {
      attributeName: 'score',
      label: 'Score',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Score of the tag'
    },
  ],
};